import axios from 'axios';
import Jsona from 'jsona';
import profile from "@/store/modules/profile-module";
import store from "@/store";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function get(params = {}) {
    let requestUrl = `${url}/me`;
    if (params.includes && params.includes.length > 0) {
        requestUrl += `?includes=${encodeURIComponent(params.includes)}`;
    }
    return axios.get(requestUrl)
        .then(response => {
            let profileData = jsona.deserialize(response.data);
            store.dispatch('setAuthenticated', true);
            return {
                list: jsona.deserialize(response.data),
                role: profileData.role,
                order_page: profileData.order_page,
                meta: response.data.meta
            };
        }).catch(reason => {
            store.dispatch('setAuthenticated', false);

        });
}

function update(profile) {

    const payload = jsona.serialize({
        stuff: profile,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/me`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function updateWorksheet(data) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/worksheet`, data, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

export default {
    get,
    update,
    updateWorksheet
};
